import candidateApi from './api';

const authService = {
  // Handle Google login redirect
  initiateGoogleLogin: () => {
    // Store the current path for redirect after login
    const currentPath = window.location.pathname;
    localStorage.setItem('candidate_redirect_path', currentPath);
    
    // Redirect to backend Google auth endpoint
    window.location.href = `${process.env.REACT_APP_CANDIDATE_API_URL }/auth/google?redirect=${currentPath}`;
  },

  // Handle callback - extract token from URL
  handleCallback: () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    if (token) {
      // Store token in localStorage
      localStorage.setItem('candidate_token', token);
      
      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname);
      
      return token;
    }
    return null;
  },

  // Get current user from backend
  getCurrentUser: async () => {
    try {
      const response = await candidateApi.get('/auth/me');
      const { user } = response.data;
      
      // Store user data in localStorage
      if (user) {
        localStorage.setItem('candidate_user', JSON.stringify(user));
      }
      
      return user;
    } catch (error) {
      // Clear invalid session
      authService.clearSession();
      throw error.response?.data || error.message;
    }
  },

  // Logout candidate
  logout: async () => {
    try {
      await candidateApi.post('/auth/logout');
      return true;
    } catch (error) {
      console.error('Logout error:', error);
      return false;
    } finally {
      authService.clearSession();
    }
  },

  // Clear session data
  clearSession: () => {
    localStorage.removeItem('candidate_token');
    localStorage.removeItem('candidate_user');
    localStorage.removeItem('candidate_redirect_path');
  },

  // Get auth token
  getToken: () => {
    return localStorage.getItem('candidate_token');
  },

  // Get stored user data
  getStoredUser: () => {
    try {
      const userStr = localStorage.getItem('candidate_user');
      return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
      return null;
    }
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem('candidate_token');
    const user = authService.getStoredUser();
    return !!(token && user);
  },

  // Get redirect path
  getRedirectPath: () => {
    return localStorage.getItem('candidate_redirect_path') || '/candidate/dashboard';
  },

  // Clear redirect path
  clearRedirectPath: () => {
    localStorage.removeItem('candidate_redirect_path');
  }
};

export default authService;